import VerifyWithHeadsup from './VerifyWithHeadsup';
export default VerifyWithHeadsup;
